import { Body, Spacer } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'
import { BillType } from '../../../../graphql/generated/graphql'
import { BillIcon, typeDescription } from '../bills/BillIcon'

export const TokenImage = styled.img`
    height: 30px;
    width: 30px;
`

export const ItemWrapper = styled.div`
    padding: 0;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    height: 48px;
`

export const BillListItem: React.VFC<{ type: BillType; style?: React.CSSProperties }> = ({
    type,
    style,
}) => {
    return (
        <ItemWrapper style={style}>
            <BillIcon type={type} />
            <Spacer width={16} />
            <Body.Med size={16}>{typeDescription[type]}</Body.Med>
        </ItemWrapper>
    )
}
